<template>
  <div>
    <div @click="modalTime">
      <MasterLayout>
        <div class="update_price_container">
          <div
            class="update_price_header price__bg"
            :style="[
              {
                backgroundImage: `linear-gradient(rgb(55, 53, 53, 0.871), rgb(55, 53, 53, 0.871)), url(${backgroundUrl})`,
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                boxShadow: '2px 2px 3px #00000005',
                backgroundSize: 'cover',
              },
            ]"
          >
            <div class="price_change_container">
              <div class="row">
                <div class="col-md-6">
                  <p class="text-white text-left">
                    {{ $t("text.stationManagement.product") }}
                  </p>
                  <div ref="name_input_div">
                    <input
                      class="update_price_input"
                      type="text"
                      :placeholder="$t('text.stationManagement.selectProduct')"
                      readonly
                      v-model="product"
                      @click="toggleSelectProductDropDownMenu"
                      style="cursor: pointer; width: 100%"
                    />
                  </div>
                  <div ref="product_error_template"></div>
                  <div
                    class="select_product_drop_dwon"
                    ref="select_product_drop_dwon"
                    v-if="SelectProductDropDownMenu"
                  >
                    <hr class="mt-2" />
                    <div
                      class="row mt-2 active_validity_drop_down_list align-items-center"
                      ref="balance_to_list_row"
                      v-for="(prod, index) in prodArray"
                      :key="index"
                      @click="getSelectProductDropDownMenu(`${prod}`)"
                      @blur="captureFormEvents($event)"
                    >
                      <div class="col-md-8">
                        <h3
                          class="dropdown_header_text mt-2 validity_drop_down_list"
                          ref="validity_drop_down_list"
                        >
                          {{ prod }}
                        </h3>
                      </div>
                      <div class="col-md-4 text-right"></div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <p class="text-white text-left">
                    {{ $t("text.stationManagement.price") }}
                  </p>
                  <div>
                    <input
                      ref="price_input_div"
                      class="update_price_input"
                      :placeholder="$t('text.stationManagement.enterNewPrice')"
                      type="text"
                      v-model="price"
                      style="width: 100%"
                      @blur="captureFormEvents($refs.price_input_div)"
                    />
                  </div>
                  <div ref="price_error_message"></div>
                </div>
              </div>
            </div>

            <div class="update_submit_button_holder mt-3">
              <div class="row" style="width: 57%">
                <div class="col-md-6">
                  <button
                    v-b-modal.modal-1
                    class="update_price_button update_modal_container"
                    @click="displayModal('now')"
                    :disabled="isButtonDisabled ? true : null"
                    style="width: 100%"
                    :style="[
                      isButtonDisabled
                        ? { cursor: 'not-allowed' }
                        : { cursor: 'pointer' },
                    ]"
                  >
                    {{ $t("text.stationManagement.updatePrice") }}
                    <img
                      src="@/assets/img/git_loader.gif"
                      style="display: none"
                      width="35px"
                      height="35px"
                      class="ml-3 loader"
                    />
                  </button>
                </div>
                <div class="col-md-6">
                  <button
                    class="save__btn btn_secondary"
                    @click="hideButton($event)"
                    ref="update_later_btn_1"
                    style="
                      outline-width: 0;
                      font-size: 16px;
                      border-radius: 3px;
                      padding: 12px;
                      width: 100%;
                    "
                    :disabled="isButtonDisabled ? true : null"
                    :style="[
                      isButtonDisabled
                        ? { cursor: 'not-allowed' }
                        : { cursor: 'pointer' },
                    ]"
                  >
                    {{ $t("text.priceManagement.scheduleUpdate") }}
                    <span>
                      <img
                        src="@/assets/img/git_loader.gif"
                        style="display: none"
                        width="25px"
                        class="loader2 ml-2"
                      />
                    </span>
                  </button>
                  <div
                    class="date__div"
                    ref="update_later_div"
                    style="display: none"
                  >
                    <div>
                      <vue-ctk-date-time-picker
                        id="DateTimePicker"
                        v-model="schedulePriceChangeDate"
                        color="#4b2d73"
                        :locale="this.$root.$i18n.locale"
                        format="YYYY-MM-DD h:mm a"
                        formatted="DD/MM/YYYY h:mm a"
                        :label="$t('text.calendar.selectDateAndTime')"
                      />
                    </div>
                    <div class="mt-3">
                      <button
                        class="update_modal_container save__btn record_expense_btn save__btn record_expense_btn mr-2 btn_primary_color"
                        style="width: 75%; font-size: 11px"
                        @click="displayModal('later')"
                        ref="update_later"
                        :disabled="isButtonDisabled ? true : null"
                        :style="[
                          isButtonDisabled
                            ? { cursor: 'not-allowed' }
                            : { cursor: 'pointer' },
                        ]"
                      >
                        Schedule Price Update<span></span>
                      </button>
                      <img
                        src="@/assets/img/remove (1).png"
                        style="float: right; cursor: pointer"
                        @click="hidePriceSheduleDiv"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="update_card_container">
            <p
              class="update_card_title_price"
              :class="
                !availableProducts.includes(
                  countryProducts.productsLower.product1,
                )
                  ? 'disabledColor'
                  : null
              "
            >
              {{ $t("text.stationManagement.currentPrice") }}
            </p>
            <div class="card_holders">
              <div
                class="update_card"
                :class="
                  !availableProducts.includes(
                    countryProducts.productsLower.product1,
                  )
                    ? 'hideCalButton disabledCursor'
                    : null
                "
              >
                <div
                  class="update_card_color blue_card"
                  :class="
                    !availableProducts.includes(
                      countryProducts.productsLower.product1,
                    )
                      ? 'hideCalButton'
                      : null
                  "
                >
                  <p
                    :class="
                      !availableProducts.includes(
                        countryProducts.productsLower.product1,
                      )
                        ? 'disabledColor'
                        : null
                    "
                  >
                    {{ countryProducts.products.product1 }}
                  </p>
                </div>
                <div
                  class="update_card_small_color blue_card"
                  :class="
                    !availableProducts.includes(
                      countryProducts.productsLower.product1,
                    )
                      ? 'hideCalButton'
                      : null
                  "
                ></div>
                <p
                  class="update_card_desciption"
                  :class="
                    !availableProducts.includes(
                      countryProducts.productsLower.product1,
                    )
                      ? 'disabledColor'
                      : null
                  "
                >
                  {{ $t("text.stationManagement.currentlySellingAt") }}
                </p>
                <p
                  class="update_card_price blue_card_color"
                  :class="
                    !availableProducts.includes(
                      countryProducts.productsLower.product1,
                    )
                      ? 'disabledColor'
                      : null
                  "
                >
                  {{ branch ? branch.currencyCode : "" }}
                  {{ convertThousand(pmsPrice) }}
                  <!-- {{ $n(pmsPrice, 'currency') }} -->
                </p>
              </div>
              <div
                class="update_card"
                :class="
                  !availableProducts.includes(
                    countryProducts.productsLower.product2,
                  )
                    ? 'hideCalButton disabledCursor'
                    : null
                "
              >
                <div
                  class="update_card_color orange_card"
                  :class="
                    !availableProducts.includes(
                      countryProducts.productsLower.product2,
                    )
                      ? 'hideCalButton'
                      : null
                  "
                >
                  <p
                    :class="
                      !availableProducts.includes(
                        countryProducts.productsLower.product2,
                      )
                        ? 'disabledColor'
                        : null
                    "
                  >
                    {{ countryProducts.products.product2 }}
                  </p>
                </div>
                <div
                  class="update_card_small_color orange_card"
                  :class="
                    !availableProducts.includes(
                      countryProducts.productsLower.product2,
                    )
                      ? 'hideCalButton'
                      : null
                  "
                ></div>
                <p
                  class="update_card_desciption"
                  :class="
                    !availableProducts.includes(
                      countryProducts.productsLower.product2,
                    )
                      ? 'disabledColor'
                      : null
                  "
                >
                  {{ $t("text.stationManagement.currentlySellingAt") }}
                </p>
                <p
                  class="update_card_price orange_card_color"
                  :class="
                    !availableProducts.includes(
                      countryProducts.productsLower.product2,
                    )
                      ? 'disabledColor'
                      : null
                  "
                >
                  <!-- {{ $n(agoPrice, 'currency') }} -->
                  {{ branch ? branch.currencyCode : "" }}
                  {{ convertThousand(agoPrice) }}
                </p>
              </div>
              <div
                class="update_card"
                :class="
                  !availableProducts.includes(
                    countryProducts.productsLower.product3,
                  )
                    ? 'hideCalButton disabledCursor'
                    : null
                "
              >
                <div
                  class="update_card_color lemon_card"
                  :class="
                    !availableProducts.includes(
                      countryProducts.productsLower.product3,
                    )
                      ? 'hideCalButton'
                      : null
                  "
                >
                  <p
                    :class="
                      !availableProducts.includes(
                        countryProducts.productsLower.product3,
                      )
                        ? 'disabledColor'
                        : null
                    "
                  >
                    {{ countryProducts.products.product3 }}
                  </p>
                </div>
                <div
                  class="update_card_small_color lemon_card"
                  :class="
                    !availableProducts.includes(
                      countryProducts.productsLower.product3,
                    )
                      ? 'hideCalButton'
                      : null
                  "
                ></div>
                <p
                  class="update_card_desciption"
                  :class="
                    !availableProducts.includes(
                      countryProducts.productsLower.product3,
                    )
                      ? 'disabledColor'
                      : null
                  "
                >
                  {{ $t("text.stationManagement.currentlySellingAt") }}
                </p>
                <p
                  class="update_card_price lemon_card_color"
                  :class="
                    !availableProducts.includes(
                      countryProducts.productsLower.product3,
                    )
                      ? 'disabledColor'
                      : null
                  "
                >
                  {{ branch ? branch.currencyCode : "" }}
                  {{ convertThousand(dpkPrice) }}
                  <!-- {{ $n(dpkPrice, 'currency') }} -->
                </p>
              </div>
              <div
                class="update_card"
                :class="
                  !availableProducts.includes(
                    countryProducts.productsLower.product4,
                  )
                    ? 'hideCalButton disabledCursor'
                    : null
                "
              >
                <div
                  class="update_card_color purple_card"
                  :class="
                    !availableProducts.includes(
                      countryProducts.productsLower.product4,
                    )
                      ? 'hideCalButton'
                      : null
                  "
                >
                  <p
                    :class="
                      !availableProducts.includes(
                        countryProducts.productsLower.product4,
                      )
                        ? 'disabledColor'
                        : null
                    "
                  >
                    {{ countryProducts.products.product4 }}
                  </p>
                </div>
                <div
                  class="update_card_small_color purple_card"
                  :class="
                    !availableProducts.includes(
                      countryProducts.productsLower.product4,
                    )
                      ? 'hideCalButton'
                      : null
                  "
                ></div>
                <p
                  class="update_card_desciption"
                  :class="
                    !availableProducts.includes(
                      countryProducts.productsLower.product4,
                    )
                      ? 'disabledColor'
                      : null
                  "
                >
                  {{ $t("text.stationManagement.currentlySellingAt") }}
                </p>
                <p
                  class="update_card_price purple_card_color"
                  :class="
                    !availableProducts.includes(
                      countryProducts.productsLower.product4,
                    )
                      ? 'disabledColor'
                      : null
                  "
                >
                  {{ branch ? branch.currencyCode : "" }}
                  {{ convertThousand(lpgPrice) }}
                  <!-- {{ $n(lpgPrice, 'currency') }} -->
                </p>
              </div>
            </div>
          </div>
        </div>
      </MasterLayout>
    </div>
    <div
      v-bind:class="[
        'update_modal',
        showUpdateModal ? 'show_update_modal' : 'hide_update_modal',
      ]"
    >
      <p class="update_modal_text">
        {{ $t("text.passwordPrompt.pleaseInput") }}
      </p>
      <input
        :placeholder="$t('text.passwordPrompt.password')"
        type="password"
        class="update_modal_input"
        ref="password"
      />
      <div class="update_modal_actions">
        <button
          @click="showUpdateModal = !showUpdateModal"
          class="update_cancel_button"
        >
          {{ $t("text.passwordPrompt.cancel") }}
        </button>
        <button @click="updatePrice" class="update_submit_button">
          {{ $t("text.passwordPrompt.submit") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import MasterLayout from "@/views/Branch/MasterLayout.vue";
import backgroundUrl from "@/assets/img/update-price.png";
import configObject from "@/config";
import countryProducts from "@/products";

import JQuery from "jquery";
let $ = JQuery;

export default {
  name: "CurrentPrice",
  components: {
    MasterLayout,
  },
  data() {
    return {
      // countryProducts: localStorage.getItem('countryProducts') ? JSON.parse(localStorage.countryProducts) : countryProducts,
      showUpdateModal: false,
      branchId: null,
      branch: {},
      backgroundUrl,
      prodArray: [],
      pmsPrice: 0,
      agoPrice: 0,
      dpkPrice: 0,
      lpgPrice: 0,
      price: 0,
      prodList: [],
      mode: "now",
      SelectProductDropDownMenu: false,
      product: null,
      isButtonDisabled: false,
      hasLpg: null,
      hasAgo: null,
      hasPms: null,
      hasDpk: null,
      availableProducts: [],
      schedulePriceChangeDate: "2020-07-09 20:26",
      schedulePriceChangeTime: "",
    };
  },
  created() {
    this.$eventHub.$on("companyId", (companyId) => {
      this.$router.replace({
        query: {
          branchId: this.$route.query.branchId,
          companyId,
        },
      });
    });
    this.getToday();
    document.title = "Update Price:: Epump Retail Outlet";
    if (localStorage.getItem("userDetails") === "null") {
      this.$router.push({ path: "/" });
    } else if (configObject.authConfig() === null) {
      window.location.reload();
    }
    $(".e-input").keyup(function (e) {
      searchFun(e);
    });
    function searchFun(event) {
      var grid = document.getElementsByClassName("e-grid")[0].ej2_instances[0];
      var value = event.target.value;
      grid.search(value);
    }

    this.$eventHub.$on("branch", (branch) => {
      this.branch = branch;
      document.title = `Update Price:: ${branch.name} Retail Outlet`;
    });
  },
  computed: {
    countryProducts: function () {
      return this.$store.getters.getCountryProducts;
    },
  },
  beforeDestroy() {},

  watch: {
    branch: function (newBranch, oldBranch) {
      if (newBranch.id) {
        if (this.$route.query.branchId) {
          this.branchId = this.branch.id;
          if (this.branchId !== null) {
            this.getProductPrices();
            this.getHistoryChartsData();
          }
        } else {
          if (this.branch.id) {
            this.branchId = this.branch.id;
          }
          if (this.branchId !== null) {
            this.getProductPrices();
            this.getHistoryChartsData();
          }
        }
      }
    },
  },
  mounted() {
    this.checkViewOnly();
  },
  methods: {
    checkViewOnly() {
      this.isButtonDisabled = this.$store.getters.getViewOnly;
    },
    hidePriceSheduleDiv() {
      this.$refs.update_later_div.style.display = "none";
      this.$refs.update_later_btn_1.style.display = "block";
    },
    getToday() {
      let d = new Date(),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      var hours = d.getHours();
      var minutes = d.getMinutes();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      hours = hours < 10 ? "0" + hours : hours;
      var strTime = hours + ":" + minutes + " " + ampm;

      let todaysDate = [year, month, day].join("-") + " " + strTime;
      this.schedulePriceChangeDate = todaysDate;
    },
    hideButton($event) {
      $event.preventDefault();
      $event.target.style.display = "none";
      this.$refs.update_later_div.style.display = "block";
    },
    displayModal(mode) {
      this.mode = mode;
      if (!this.price) {
        this.$toast.open({
          message: this.$t("text.stationManagement.priceMissing"),
          type: "error",
          duration: 5000,
        });
        return;
      }
      this.showUpdateModal = !this.showUpdateModal;
    },
    modalTime($event) {
      if ($event.target.classList.contains("update_modal_container")) {
        return;
      }
      if (this.showUpdateModal) {
        this.showUpdateModal = !this.showUpdateModal;
      }
    },
    toggleSelectProductDropDownMenu() {
      this.SelectProductDropDownMenu = !this.SelectProductDropDownMenu;
    },
    getSelectProductDropDownMenu(productDropdownItem) {
      this.product = productDropdownItem;
      this.price = this.prodList.filter(
        (prod) => prod.name.toLowerCase() == productDropdownItem.toLowerCase(),
      )[0].price;
      this.SelectProductDropDownMenu = !this.SelectProductDropDownMenu;
    },
    captureFormEvents(ref) {
      if (ref.placeholder === this.$t("text.stationManagement.enterNewPrice")) {
        if (ref.value === "") {
          this.$refs.price_error_message.style.display = "block";
          this.$refs.price_error_message.innerHTML = this.$t(
            "text.stationManagement.priceMissing",
          );
          ref.style.border = "1px solid red";
          this.$refs.price_error_message.style.color = "red";
          this.formIsValid = false;
        } else {
          if (ref.value < 1) {
            this.$refs.price_error_message.style.display = "block";
            this.$refs.price_error_message.innerHTML = this.$t(
              "text.stationManagement.invalidPrice",
            );
            ref.style.border = "1px solid red";
            this.$refs.price_error_message.style.color = "red";
            this.formIsValid = false;
          } else {
            this.$refs.price_error_message.style.display = "none";
            this.$refs.price_error_message.innerHTML = "";
            ref.style.border = "1px solid rgb(75, 44, 114)";
            this.formIsValid = true;
          }
        }
      }
    },
    getProductPrices() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Products/${this.branchId}`,
          configObject.authConfig(),
        )
        .then((response) => {
          response.data.forEach((el) => {
            this.availableProducts.push(el.name.toLowerCase());
          });
          this.showLoader = false;
          this.prodList = response.data;
          let pms = response.data.filter(
            (product) =>
              product.name.toLowerCase() ==
              this.countryProducts.productsLower.product1,
          );
          if (pms.length > 0) {
            this.pmsPrice = pms[0].price;
            this.product = this.countryProducts.products.product1;
          }
          let ago = response.data.filter(
            (product) =>
              product.name.toLowerCase() ==
              this.countryProducts.productsLower.product2,
          );
          if (ago.length > 0) {
            this.agoPrice = ago[0].price;
            if (!this.product) {
              this.product = this.countryProducts.products.product2;
            }
          }
          let dpk = response.data.filter(
            (product) =>
              product.name.toLowerCase() ==
              this.countryProducts.productsLower.product3,
          );

          if (dpk.length > 0) {
            this.dpkPrice = dpk[0].price;
            if (!this.product) {
              this.product = this.countryProducts.products.product3;
            }
          }
          let lpg = response.data.filter(
            (product) =>
              product.name.toLowerCase() ==
              this.countryProducts.productsLower.product4,
          );
          if (lpg.length > 0) {
            this.lpgPrice = lpg[0].price;
            if (!this.product) {
              this.product = this.countryProducts.products.product4;
            }
          }
          const prod = this.product;
          this.price =
            prod === this.countryProducts.products.product2
              ? this.agoPrice
              : prod === this.countryProducts.products.product3
              ? this.dpkPrice
              : prod === this.countryProducts.products.product4
              ? this.lpgPrice
              : this.pmsPrice;
          this.prodArray = response.data.map((prod) => {
            return prod.name;
          });
        })
        .catch((error) => {});
    },
    getHistoryChartsData() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Branch/FiveDaySale/${this.branchId}`,
          configObject.authConfig(),
        )
        .then((response) => {
          response.data.forEach((el) => {
            if (
              el.product.toLowerCase() ===
              this.countryProducts.productsLower.product4
            ) {
              this.hasLpg = true;
              return;
            } else {
              this.hasLpg = false;
            }
          });
        })
        .catch((error) => {});
    },
    updatePrice() {
      if (!this.$refs.password.value) {
        this.$toast.open({
          message: this.$t("text.errors.passwordMissing"),
          type: "error",
          duration: 5000,
        });
        return;
      }
      const passwordValue = this.$refs.password.value;
      this.showUpdateModal = !this.showUpdateModal;
      this.$refs.password.value = "";
      this.captureFormEvents(this.$refs.price_input_div);
      if (
        this.$refs.price_input_div.value === "" ||
        this.$refs.price_input_div.value < 1
      ) {
        return;
      }
      this.showLoader = true;
      let data;
      let url;
      if (this.mode == "later") {
        url = `${configObject.apiBaseUrl}/Company/updatePrice`;
        const dateTime = this.$moment(`${this.schedulePriceChangeDate}`).format(
          "YYYY-MM-DD HH:mm:ss",
        );
        let newDateTime = new Date(dateTime);
        let updatedDateTime = new Date(
          newDateTime.setHours(newDateTime.getHours() + 1),
        ).toISOString();
        data = {
          id: this.branchId,
          productId: this.prodList.filter(
            (prod) => prod.name.toLowerCase() == this.product.toLowerCase(),
          )[0].productId,
          price: parseFloat(this.price),
          branchId: this.branchId,
          password: passwordValue,
          scheduleDate: updatedDateTime,
        };
      } else {
        url = `${configObject.apiBaseUrl}/Products/ChangePrice`;
        data = {
          branchId: this.branchId,
          productId: this.prodList.filter(
            (prod) => prod.name.toLowerCase() == this.product.toLowerCase(),
          )[0].productId,
          price: parseFloat(this.price),
          password: passwordValue,
          id: this.branchId,
        };
      }
      this.isButtonDisabled = true;
      this.axios
        .post(url, data, configObject.authConfig())
        .then(() => {
          this.showLoader = false;
          this.$toast.open({
            message: this.$t("text.stationManagement.successfullyChanged"),
            type: "success",
            duration: 5000,
          });
          this.getProductPrices();
          this.isButtonDisabled = false;
          $(".loader").hide();
        })
        .catch((error) => {
          this.isButtonDisabled = false;
          this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 5000,
          });
          $(".loader").hide();
        });
    },
  },
};
</script>
